import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DateFieldComponent from "../../../components/inputs/Datefield/DatefieldComponent";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { useAppDispatch } from "../../../hooks/hooks";
import { useGetBooksQuery } from "../../../hooks/library/useGetBooksQuery";
import { resetReservationData } from "../../../redux/slices/library/reservation";
import { resetUserData } from "../../../redux/slices/users/user";
import { RootState } from "../../../redux/store";
import { routes } from "../../../routes";
import { updateReservation } from "../../../services/library/reservation";
import { ReservationType } from "../../../types/Library";
import { UserType } from "../../../types/User";
import { UserPreview } from "../../Users/UserPreview";
import { ReservationFormValidation } from "./ReservationFormValidation";

export const UpdateReservation = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userData = useSelector((state: RootState) => state.user);

    const mutation = useMutation({ mutationFn: updateReservation, mutationKey: "updateReservation" });
    const reservationFormData = useSelector((state: RootState) => state.reservation);
    const { data: booksData, status: statusBooks, isLoading: isLoadingBooks, isError: isErrorBooks, refetch: refreshBooks } = useGetBooksQuery({
        PageSize: 4000,
        PageNumber: 1,
    });
    type ReservationFormValues = ReservationType & {
        user?: UserType;
        searchNuit?: string,
        searchBi?: string,
    };
    const { control, handleSubmit, formState: { errors } } = useForm<ReservationFormValues>({
        resolver: yupResolver(ReservationFormValidation),
        defaultValues: { ...reservationFormData, user: userData },
        mode: "onBlur",
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Reserva atualizada com sucesso!");
            handleBack();
        } catch (error: any) {
            toast.error(`Erro: ${error.message}`);
        }
    });
    const handleBack = () => {
        navigate(routes.reservations);
        dispatch(resetReservationData());
        dispatch(resetUserData());
    };

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <UserPreview />
                    <SelectComponent
                        label="Livro"
                        options={booksData?.items.map((book) => ({
                            value: book?.id ?? "",
                            label: `${book?.title}`
                        }))}
                        errors={errors}
                        control={control}
                        name="idBook"
                        itemsLoading={isLoadingBooks}
                        itemsError={isErrorBooks}
                        style={{ width: '100%' }}
                        required={true}
                    />
                    <Flex direction='row' gap='2'>
                        <DateFieldComponent
                            name="startDate"
                            label="Data de Início"
                            control={control}
                            errors={errors}
                            fieldProps={{ placeholder: "Data de Início" }}
                            style={{ width: '100%' }}

                        />
                        <DateFieldComponent
                            name="endDate"
                            label="Data de Término"
                            control={control}
                            errors={errors}
                            fieldProps={{ placeholder: "Data de Término" }}
                            style={{ width: '100%' }}

                        />
                    </Flex>
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading}>
                            {mutation.isLoading ? <Spinner loading /> : <EnterIcon />}
                            Guardar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
